export class UIEventHandler {

    public static preventDefaults($event?: UIEvent, preventDefault = true, stopImmediatePropagation = true, stopPropagation = true): void {

        if (!$event) {
            return;
        }

        if (preventDefault) {
            $event.preventDefault();
        }

        if (stopImmediatePropagation) {
            $event.stopImmediatePropagation();
        }

        if (stopPropagation) {
            $event.stopPropagation();
        }
    }
}